'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.PlanConfirmationModalContainer = exports.modalConfig = exports.mapDispatchToProps = exports.mapStateToProps = undefined;

var _reactRedux = require('react-redux');

var _Modal = require('decorators/Modal/Modal');

var _Modal2 = _interopRequireDefault(_Modal);

var _Sagas = require('decorators/Sagas/Sagas');

var _decorator = require('helpers/decorator');

var _bound = require('redux/saga/entities/bound');

var _PlanConfirmationModal = require('./PlanConfirmationModal.saga');

var _PlanConfirmationModal2 = require('./PlanConfirmationModal');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var mapStateToProps = exports.mapStateToProps = function mapStateToProps(state) {
  return {
    error: _bound.createSubscription.error(state),
    subscription: _bound.subscription.select(state),
    leaving: state.page.flags[_PlanConfirmationModal.LEAVING_PAGE_FLAG]
  };
};

var mapDispatchToProps = exports.mapDispatchToProps = {
  switchSubscription: _PlanConfirmationModal.switchSubscription
};

var modalConfig = exports.modalConfig = {
  headerClass: 'modal--640 modal__plan-confirmation'
};

var PlanConfirmationModalContainer = exports.PlanConfirmationModalContainer = (0, _decorator.decorateWith)((0, _Modal2.default)(modalConfig), (0, _Sagas.withSagas)({ watch: _PlanConfirmationModal.watchPlanConfirmationModalSagas }), (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps))(_PlanConfirmationModal2.PlanConfirmationModal);